export default __webpack_public_path__ + "static/media/landing-agent-feature-1.6b5de368.svg";